module.exports = __webpack_public_path__ + "media/typy/motocykle@2x-d35a6ead.png";